"use client";
import React, { useState } from "react";
import "./CreateCampaign.css";
import NewCampaignInfo from "./NewCampaignInfo";
import AudienceContent from "./AudienceContent";
import CampaignBudget from "./CampaignBudget";
import CampaignPayment from "./CampaignPayment";
import { CampaignProvider } from "../../contexts/CampaignContext";

const CreateCampaign = () => {
  const [currentStep, setCurrentStep] = useState(1); // 1: Campaign Info, 2: Audience & Content, 3: Campaign Budget
  // 注释掉 4: Payment

  const handleNextStep = () => {
    if (currentStep < 3) { // 修改为3步
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleNavClick = (step) => {
    // 检查第一步是否完成，如果要点击第二步或第三步
    if (step >= 2) {
      const campaignInfoData = JSON.parse(sessionStorage.getItem('campaign_info_form') || '{}');
      const isStep1Valid = (
        campaignInfoData.campaignName?.trim() !== "" &&
        campaignInfoData.productDescription?.trim() !== "" &&
        campaignInfoData.landingPage?.trim() !== ""
      );
      
      if (!isStep1Valid) {
        console.log('请先完成 Campaign Info 的必填字段');
        return; // 不允许跳转
      }
    }
    
    setCurrentStep(step);
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return <NewCampaignInfo onNext={handleNextStep} />;
      case 2:
        return (
          <AudienceContent onNext={handleNextStep} onBack={handlePrevStep} />
        );
      case 3:
        return (
          <CampaignBudget onNext={handleNextStep} onBack={handlePrevStep} />
        );
      // 注释掉 Payment 步骤
      // case 4:
      //   return <CampaignPayment onBack={handlePrevStep} />;
      default:
        return <NewCampaignInfo onNext={handleNextStep} />;
    }
  };

  return (
    <CampaignProvider>
      <main className="campaigninfoAlthrun">
        <div className="layout-container">
          <div className="sidebar-column">
            <nav className="sidebar">
              <h1 className="title">Create Campaign</h1>
              <p className="campaign-intro">
                Start your influencer campaign with just a few clicks
              </p>
              <ul className="nav-list">
                <li
                  className={`menu-item ${currentStep === 1 ? "menu-item-active" : ""}`}
                  onClick={() => handleNavClick(1)}
                >
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/2e5c24e8b235fcbbb292bdbf7256eac019b358fa?placeholderIfAbsent=true&apiKey=dc2f6a1e66164bfb9d194f96d43a57dd"
                    alt=""
                    className="menu-icon"
                  />
                  <span className="menu-text">Campaign Info</span>
                </li>
                <li
                  className={`menu-item ${currentStep === 2 ? "menu-item-active" : ""}`}
                  onClick={() => handleNavClick(2)}
                >
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/4327f35424ea6a0e92e1f87904bf1b108d42dcfb?placeholderIfAbsent=true&apiKey=dc2f6a1e66164bfb9d194f96d43a57dd"
                    alt=""
                    className="menu-icon"
                  />
                  <span className="menu-text">Audience & Content</span>
                </li>
                <li
                  className={`menu-item ${currentStep === 3 ? "menu-item-active" : ""}`}
                  onClick={() => handleNavClick(3)}
                >
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/31fca24d4e1764295594372a0781d82d676322d3?placeholderIfAbsent=true&apiKey=dc2f6a1e66164bfb9d194f96d43a57dd"
                    alt=""
                    className="menu-icon"
                  />
                  <span className="menu-text">Campaign Budget</span>
                </li>
                {/* 注释掉 Payment 步骤 */}
                {/* <li
                  className={`menu-item ${currentStep === 4 ? "menu-item-active" : ""}`}
                  onClick={() => handleNavClick(4)}
                >
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/31fca24d4e1764295594372a0781d82d676322d3?placeholderIfAbsent=true&apiKey=dc2f6a1e66164bfb9d194f96d43a57dd"
                    alt=""
                    className="menu-icon"
                  />
                  <span className="menu-text">Payment</span>
                </li> */}
              </ul>
            </nav>
          </div>
          <div className="main-column">{renderCurrentStep()}</div>
        </div>
      </main>
    </CampaignProvider>
  );
};

export default CreateCampaign;
